/* ============================================
   ETHOS LABS — Premium Product Page JS
   ============================================ */

(function() {
  'use strict';

  /* --- Purchase Option Selector --- */
  function initPurchaseOptions() {
    var options = document.querySelectorAll('.el-purchase-option');
    var priceDisplay = document.querySelector('.el-sticky-atc__price');
    var sellingPlanInput = document.getElementById('el-selling-plan');
    var quantityInput = document.getElementById('el-quantity');

    /* Seal Subscriptions selling plan ("Auto-Replenish - Save 22%" group).
       Must stay a Seal-owned plan ID — a non-Seal plan checks out fine but
       creates a subscription Seal can never bill. Also update the copy of
       this ID in initDrawerUpsell if it ever changes. */
    var SUBSCRIBE_PLAN_ID = '8357445871';
    var SINGLE_VARIANT_ID = 48200379826415;
    var BUNDLE_VARIANT_ID = 48672154157295;

    options.forEach(function(option) {
      option.addEventListener('click', function() {
        options.forEach(function(o) { o.classList.remove('el-purchase-option--active'); });
        this.classList.add('el-purchase-option--active');

        var type = this.dataset.purchaseType;
        var price = this.dataset.price;

        /* Update global purchase state — no DOM dependency */
        _activePurchase.type = type;
        _activePurchase.planId = (type === 'subscribe') ? SUBSCRIBE_PLAN_ID : '';
        _activePurchase.variantId = (type === 'bundle') ? BUNDLE_VARIANT_ID : SINGLE_VARIANT_ID;
        _activePurchase.qty = 1;

        var btn = document.querySelector('.el-add-to-cart__text');
        if (btn) {
          if (type === 'subscribe') btn.textContent = 'Add to Cart \u2014 Save 22%';
          else if (type === 'bundle') btn.textContent = 'Add 3-Pack to Cart';
          else btn.textContent = 'Add to Cart';
        }

        if (priceDisplay) {
          priceDisplay.textContent = type === 'subscribe' ? price + '/mo' : price;
        }
      });
    });
  }

  /* --- Scroll Reveal Animations --- */
  function initScrollReveal() {
    const reveals = document.querySelectorAll('.el-reveal, .el-stagger');
    if (!reveals.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (entry.target.classList.contains('el-stagger')) {
            entry.target.classList.add('el-stagger--visible');
          } else {
            entry.target.classList.add('el-reveal--visible');
          }
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -60px 0px'
    });

    reveals.forEach(el => observer.observe(el));
  }

  /* --- Parallax on Hero Image --- */
  function initParallax() {
    const img = document.querySelector('.el-product-hero__media-img');
    if (!img || window.innerWidth < 990) return;

    let ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          const scrolled = window.scrollY;
          const rate = scrolled * 0.3;
          img.style.transform = 'translateY(' + rate + 'px) scale(1.1)';
          ticking = false;
        });
        ticking = true;
      }
    });

    // Initial scale for parallax room
    img.style.transform = 'scale(1.1)';
  }

  /* --- Number Counter Animation --- */
  function initCounters() {
    const counters = document.querySelectorAll('[data-count-to]');
    if (!counters.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(el => observer.observe(el));
  }

  function animateCounter(el) {
    const target = parseInt(el.dataset.countTo);
    const suffix = el.dataset.countSuffix || '';
    const prefix = el.dataset.countPrefix || '';
    const duration = 2000;
    const start = performance.now();

    function easeOutQuart(t) {
      return 1 - Math.pow(1 - t, 4);
    }

    function update(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeOutQuart(progress);
      const current = Math.round(eased * target);
      el.textContent = prefix + current.toLocaleString() + suffix;
      if (progress < 1) requestAnimationFrame(update);
    }

    requestAnimationFrame(update);
  }

  /* --- Scroll-Driven Text Highlight --- */
  function initScrollHighlight() {
    const container = document.querySelector('.el-ingredients__scroll-text');
    if (!container) return;

    const words = container.querySelectorAll('.word');
    if (!words.length) return;

    function update() {
      const rect = container.getBoundingClientRect();
      const viewH = window.innerHeight;

      // Calculate how far through the section we've scrolled
      // Start highlighting when section enters bottom third, finish when top third
      const progress = 1 - ((rect.bottom - viewH * 0.3) / (rect.height + viewH * 0.4));
      const clamped = Math.max(0, Math.min(1, progress));
      const activeIndex = Math.floor(clamped * words.length);

      words.forEach((word, i) => {
        if (i <= activeIndex) {
          word.classList.add('active');
        } else {
          word.classList.remove('active');
        }
      });
    }

    let ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          update();
          ticking = false;
        });
        ticking = true;
      }
    });
    update();
  }

  /* --- Timeline Line Draw --- */
  function initTimeline() {
    const timeline = document.querySelector('.el-timeline');
    if (!timeline) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          timeline.classList.add('el-timeline--drawn');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    observer.observe(timeline);
  }

  /* --- Mobile Sticky Add to Cart --- */
  function initStickyATC() {
    const stickyBar = document.querySelector('.el-sticky-atc');
    const heroBtn = document.querySelector('.el-add-to-cart');
    if (!stickyBar || !heroBtn) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('el-sticky-atc--visible');
        } else {
          stickyBar.classList.add('el-sticky-atc--visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(heroBtn);

    const stickyBtn = stickyBar.querySelector('.el-sticky-atc__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        heroBtn.click();
      });
    }
  }

  /* --- FAQ Accordion --- */
  function initFAQ() {
    const faqItems = document.querySelectorAll('.el-faq__item');
    faqItems.forEach(item => {
      item.addEventListener('toggle', function() {
        if (this.open) {
          faqItems.forEach(other => {
            if (other !== this && other.open) other.open = false;
          });
        }
      });
    });
  }

  /* --- Add to Cart Handler --- */
  /* Active purchase state — updated by initPurchaseOptions click handlers */
  var _activePurchase = { type: 'subscribe', planId: '8357445871', variantId: 48200379826415, qty: 1 };

  function initAddToCart() {
    var form = document.getElementById('el-product-form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('.el-add-to-cart');
      var btnText = btn ? btn.querySelector('.el-add-to-cart__text') : null;
      var originalText = btnText ? btnText.textContent : 'Add to Cart';

      if (btn) btn.classList.add('el-add-to-cart--loading');
      if (btnText) btnText.textContent = 'Adding...';

      var variantId = _activePurchase.variantId || parseInt((form.querySelector('[name="id"]') || {}).value);

      console.log('[ATC] submitting:', _activePurchase, 'variant:', variantId);

      if (!variantId) {
        if (btnText) btnText.textContent = 'Error: no variant';
        return;
      }

      var item = { id: variantId, quantity: _activePurchase.qty };
      if (_activePurchase.planId) item.selling_plan = parseInt(_activePurchase.planId);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item], sections: 'cart-drawer,cart-icon-bubble' })
      })
      .then(function(response) {
        return response.json().then(function(json) { return { status: response.status, body: json }; });
      })
      .then(function(result) {
        if (result.status >= 400) {
          throw new Error((result.body && result.body.description) || 'Add to cart failed');
        }
        if (btnText) btnText.textContent = 'Added!';

        refreshDrawer(result.body);
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) cartDrawer.open();
        if (btn) btn.classList.remove('el-add-to-cart--loading');
        if (btnText) btnText.textContent = originalText;
      })
      .catch(function(err) {
        console.error('[ATC] error:', err);
        if (btnText) btnText.textContent = 'Error — try again';
        if (btn) btn.classList.remove('el-add-to-cart--loading');
        setTimeout(function() { if (btnText) btnText.textContent = originalText; }, 2500);
      });
    });
  }

  /* --- Product Image Gallery (Thumbnail Navigation) --- */
  function initImageGallery() {
    const mainImg = document.querySelector('.el-product-hero__media-img');
    const thumbs = document.querySelectorAll('.el-product-hero__thumb');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        const newSrc = this.dataset.image;
        if (!newSrc) return;

        thumbs.forEach(function(t) { t.classList.remove('el-product-hero__thumb--active'); });
        this.classList.add('el-product-hero__thumb--active');

        mainImg.style.opacity = '0';
        mainImg.style.transform = 'translateY(8px)';

        setTimeout(function() {
          mainImg.src = newSrc;
          mainImg.srcset = '';
          mainImg.onload = function() {
            mainImg.style.opacity = '1';
            mainImg.style.transform = 'translateY(0)';
          };
        }, 200);
      });
    });
  }

  /* --- Initialize Everything --- */
  function init() {
    initPurchaseOptions();
    initImageGallery();
    initScrollReveal();
    initParallax();
    initCounters();
    initScrollHighlight();
    initTimeline();
    initStickyATC();
    initFAQ();
    initAddToCart();
  }

  /* --- Cart Drawer Upsell Handlers --- */
  function initDrawerUpsell() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-upsell]');
      if (!btn) return;

      var action = btn.dataset.upsell;
      var VARIANT_ID = 48200379826415;
      var BUNDLE_VARIANT_ID = 48672154157295;
      var PLAN_ID = 8357445871;

      btn.classList.add('el-drawer-upsell__btn--loading');
      btn.textContent = '...';

      if (action === 'subscribe') {
        /* Clear cart, then add subscription */
        fetch('/cart/clear.js', { method: 'POST' })
          .then(function() {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{ id: VARIANT_ID, quantity: 1, selling_plan: PLAN_ID }],
                sections: 'cart-drawer,cart-icon-bubble'
              })
            });
          })
          .then(function(r) { return r.json(); })
          .then(function(data) { refreshDrawer(data); })
          .catch(function() { window.location.reload(); });

      } else if (action === 'bundle') {
        /* Check if subscription exists — if so, keep it and add 3 more. If not, add 2 more to existing. */
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var hasSubscription = false;
            var oneTimeQty = 0;
            cart.items.forEach(function(item) {
              if (item.selling_plan_allocation) hasSubscription = true;
              else if (item.variant_id === VARIANT_ID) oneTimeQty += item.quantity;
            });

            /* Add the 3-pack bundle variant */
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{ id: BUNDLE_VARIANT_ID, quantity: 1 }],
                sections: 'cart-drawer,cart-icon-bubble'
              })
            });
          })
          .then(function(r) { return r.json(); })
          .then(function(data) { refreshDrawer(data); })
          .catch(function() { window.location.reload(); });
      }
    });
  }

  function refreshDrawer(data) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || !data.sections) { window.location.reload(); return; }

    var parser = new DOMParser();
    if (data.sections['cart-drawer']) {
      var doc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
      var newItems = doc.querySelector('cart-drawer-items');
      var oldItems = cartDrawer.querySelector('cart-drawer-items');
      if (newItems && oldItems) oldItems.outerHTML = newItems.outerHTML;

      var newFooter = doc.querySelector('.cart-drawer__footer');
      var oldFooter = cartDrawer.querySelector('.cart-drawer__footer');
      if (newFooter && oldFooter) oldFooter.outerHTML = newFooter.outerHTML;

      var newUpsell = doc.querySelector('.el-drawer-upsell');
      var oldUpsell = cartDrawer.querySelector('.el-drawer-upsell');
      if (newUpsell && oldUpsell) oldUpsell.outerHTML = newUpsell.outerHTML;
      else if (newUpsell) {
        var footer = cartDrawer.querySelector('.drawer__footer');
        if (footer) footer.insertAdjacentHTML('beforebegin', newUpsell.outerHTML);
      } else if (oldUpsell) { oldUpsell.remove(); }

      cartDrawer.classList.remove('is-empty');
      var di = cartDrawer.querySelector('cart-drawer-items');
      if (di) di.classList.remove('is-empty');
      var emptyDiv = cartDrawer.querySelector('.drawer__inner-empty');
      if (emptyDiv) emptyDiv.style.display = 'none';
      var checkoutBtn = cartDrawer.querySelector('#CartDrawer-Checkout');
      if (checkoutBtn) checkoutBtn.disabled = false;
    }
    if (data.sections['cart-icon-bubble']) {
      var bDoc = parser.parseFromString(data.sections['cart-icon-bubble'], 'text/html');
      var nb = bDoc.querySelector('#cart-icon-bubble');
      var ob = document.querySelector('#cart-icon-bubble');
      if (nb && ob) ob.innerHTML = nb.innerHTML;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(); initDrawerUpsell(); });
  } else {
    init();
    initDrawerUpsell();
  }
})();
